import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getUserIdWithExpiry } from '../../utilFunctions/utilfunction';

const PrivateRoute = () => {
    const userId = getUserIdWithExpiry();

    return userId ? <Outlet /> : <Navigate to="/" replace />;
};

export default PrivateRoute;
